import React from 'react';
import styles from './TestimonialsSection.module.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Carlos G.',
      text: '¡Gané $50,000 en mi primer intento! El proceso fue rápido y sencillo.',
      avatar: 'https://via.placeholder.com/100',
    },
    {
      id: 2,
      name: 'María P.',
      text: 'Es increíble participar en sorteos desde mi casa.',
      avatar: 'https://via.placeholder.com/100',
    },
    {
      id: 3,
      name: 'José R.',
      text: 'El soporte al cliente fue excepcional. ¡Gracias Megaloto!',
      avatar: 'https://via.placeholder.com/100',
    },
  ];

  return (
    <section className={styles.testimonials}>
      <h2>Nuestros ganadores opinan</h2>
      <p className={styles.subtitle}>
        Descubre lo que otros jugadores tienen que decir sobre su experiencia con Megaloto.
      </p>
      <div className={styles.cards}>
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className={styles.card}>
            {/* <img src={testimonial.avatar} alt={testimonial.name} className={styles.avatar} /> */}
            <h3>{testimonial.name}</h3>
            <p>"{testimonial.text}"</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
